export default "__VITE_ASSET__DYVcPPnh__"